import type { NearbyStorageSpots } from "./types"

type GetStoreThumbnailOptions = {
  width?: number
  height?: number
}
export const getStoreThumbnail = (
  store: Pick<NearbyStorageSpots[0], "thumbnail" | "type">,
  { width = 480, height = 480 }: GetStoreThumbnailOptions = {},
): string => {
  if (!!store.thumbnail) {
    return `https://cdn.usebounce.com/${store.thumbnail.externalId}/-/scale_crop/${width}x${height}/center/-/enhance/`
  }

  return ""
}
